import { toast } from 'react-toastify';
import ToastMessage from '../components/common/toast-message';
import irelandApi from '../irelandApi';
import {
  GET_ADMIN_FEATURES_FULFILLED,
  GET_ADMIN_FEATURES_PENDING,
  GET_ADMIN_FEATURES_REJECTED,
  GET_ADMIN_FEATURE_FULFILLED,
  GET_ADMIN_FEATURE_PENDING,
  GET_ADMIN_FEATURE_REJECTED
} from '../reducers/featureTogglesReducer';
import { history } from '../store';

const FEATURE_TOGGLES_URL = '/api/admin';

export const getAdminFeatureToggle = id => (dispatch) => {
  dispatch({
    type: GET_ADMIN_FEATURE_PENDING
  });

  return irelandApi
    .get(`${FEATURE_TOGGLES_URL}/feature_toggles/${id}`)
    .then((response) => {
      const { attributes } = response.data.data;
      const payload = {
        data: {
          attributes: {
            name: attributes.name,
            description: attributes.description,
            enabled: `${attributes.enabled}`,
          }
        }
      };

      dispatch({
        type: GET_ADMIN_FEATURE_FULFILLED,
        payload
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_ADMIN_FEATURE_REJECTED,
        payload: error.response.data
      });
    });
};

export const getAdminFeatureToggles = () => (dispatch) => {
  dispatch({
    type: GET_ADMIN_FEATURES_PENDING
  });

  return irelandApi
    .get(`${FEATURE_TOGGLES_URL}/feature_toggles`)
    .then((response) => {
      dispatch({
        type: GET_ADMIN_FEATURES_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_ADMIN_FEATURES_REJECTED,
        payload: error.data
      });
    });
};

export const updateAdminFeatureToggle = (id, payload) =>
  irelandApi
    .patch(`${FEATURE_TOGGLES_URL}/feature_toggles/${id}`, { feature_toggle: payload })
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Feature Toggle has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving Feature Toggle"/>);

      // eslint-disable-next-line no-prototype-builtins
      const errorData = error.hasOwnProperty('response') ? error.response.data.errors : [];

      return Promise.reject(errorData);
    }).then(() => {
      history.push('/admin/feature-toggles');
    });
